<template>
    <SimpleTable formclass="pages/Cards/form" endpoint="api/v2/card" :aditionalColumns="headers">
        <template v-slot="data">
            <h1>Cartões</h1>
            <v-divider class="mb-4" />
            <v-layout wrap class="my-12">
                <v-flex xs12 sm6>
                    <v-card color="primary">
                        <v-card-text class="white--text">
                            <div class="headline mb-2">
                                <v-icon dark>functions</v-icon>
                                {{ total(data.items) }}
                            </div>
                            Cadastrados
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-card color="primary">
                        <v-card-text class="white--text">
                            <div class="headline mb-2">
                                <v-icon dark>functions</v-icon>
                                {{ active(data.items) }}
                            </div>
                            Ativos
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";

export default {
    components: { SimpleTable },

    data() {
        return {
            headers: [
                { text: "Usuário", value: "user.email", align: "right", sortable: true },
                { text: "Status", value: "status", align: "right", sortable: true },
                { text: "Tipo", value: "type", align: "right", sortable: true },
                { text: "Código cartão", value: "code", align: "right", sortable: true },
            ],
        };
    },

    methods: {
        total(items) {
            return Number.parseFloat(items.length).toFixed(0);
        },
        active(items) {
            return Number.parseFloat(items.reduce((sum, i) => (i.status == "OK" ? sum + 1 : sum), 0)).toFixed(0);
        },
    },
};
</script>